module.exports = __webpack_public_path__ + "static/img/loaddingShow.f28e551.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loaddingShow.png
// module id = Jlha
// module chunks = 1